<template>
  <div>
    <v-row>
      <v-col cols="12 py-0">
        <ValidationObserver ref="observer">
          <v-card>
            <v-container fluid>
              <v-row v-if="selectedIngredientsData">
                <v-row>
                  <v-col
                    cols="auto"
                    v-for="(
                      SelectedIngredient, index
                    ) in selectedIngredientsData"
                    :key="name"
                  >
                    <v-card
                      style="border-radius: 10px !important"
                      width="200"
                      height="280px"
                    >
                      <v-row>
                        <v-col cols="12">
                          <div>
                            <v-img
                              v-if="SelectedIngredient.ingredient.image"
                              :src="SelectedIngredient.ingredient.image"
                              alt="Snow"
                              height="150px"
                              width="100%"
                            />
                            <v-img
                              v-else
                              src="../../../../assets/Img.jpg"
                              alt="Snow"
                              height="150px"
                              width="100%"
                            />
                          </div>
                          <div class="head">
                            {{ SelectedIngredient.ingredient.name }}
                          </div>

                          <v-divider> </v-divider>
                        </v-col>
                        <!-- <div class="pricetag">
                          Price
                        </div> -->
                        <v-row>
                          <v-col cols="4" class="pl-6 py-2"> </v-col>

                          <v-col cols="4" class="px-1">
                            <ValidationProvider
                              v-slot="{ errors }"
                              name="Price"
                              rules="required"
                            >
                              <v-text-field
                                outlined
                                disabled
                                type="number"
                                @input="SelectedIngredient.priceError = []"
                                v-model="SelectedIngredient.price"
                                :error-messages="SelectedIngredient.priceError"
                                label="Price"
                                class="price-field"
                              ></v-text-field>
                            </ValidationProvider>
                          </v-col>
                          <v-col cols="4" class="px-1 py-2">
                            <!-- <v-btn icon color="green"><v-icon>mdi-plus-box</v-icon></v-btn> -->
                          </v-col>
                        </v-row>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-row>
            </v-container>
          </v-card>
        </ValidationObserver>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { required, email, max, regex } from "vee-validate/dist/rules";

import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";

setInteractionMode("eager");

extend("required", {
  ...required,
  message: "{_field_} is required",
});

extend("email", {
  ...email,
  message: "Email must be valid",
});

export default {
  data: () => ({
    SelectedIngredients: null,
    selectedIngredientsData: [],
    showdatas: false,
    SelectBox: true,
    errors: [],
    messages: [],

    Ingredients: [],
  }),
  props: {
    selectedIngredientsData: {
      type: Array,
      default: [],
    },
  },
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  created() {
    this.GetIngredients();
  },

  methods: {
    GetIngredients(query = "") {
      this.$store
        .dispatch("ingredients/GetIngredients", {
          query: query.searchQuery,
        })
        .then((res) => {
          console.log(res);
          this.Ingredients = res.data.data;
        })
        .catch((err) => {});
    },
    async submit() {
      const isValid = await this.$refs.observer.validate();
      let error = false;
      this.selectedIngredientsData.map((p) => {
        if (!p.price || p.price <= 0) {
          p.priceError = [];
          error = true;
          p.priceError.push("price is required");
        }
      });
      if (isValid && !error) {
        this.$emit("nextTab");
        this.GetDatasIngredients();
      } else if (isValid) {
      }
    },

    close(selectdata, index) {
      if (selectdata) {
        this.selectedIngredientsData.splice(index, 1);
      }
    },
    GetDatasIngredients() {
      return this.selectedIngredientsData;
    },
    SubmitData() {
      this.showdatas = true;
      let selected = this.Ingredients.find(
        (p) => p.id == this.SelectedIngredients
      );
      if (selected) {
        this.selectedIngredientsData.push({ ingredient: selected });
      }
    },
  },
};
</script>
<style>
.price {
  margin-top: -15px;
  margin-left: 68px;
}
.head {
  text-align: center;
  text-overflow: inherit;
  font-size: 13px;
  font-weight: 750;
  background: whitesmoke;
}

.TypeImage {
  width: 100%;
  background-image: url("../../../../assets/Img.jpg");
  /* background-image: url("https://cdn.pixabay.com/photo/2015/04/23/22/00/tree-736885__340.jpg"); */
}
/* .pricetag {
  font-size: 15px;
  font-weight: 800;
  text-align: center;
  margin-left: 98px;
} */
.closebutton {
  position: absolute;
  top: 5px;
  z-index: 2;
  margin-left: 160px !important;
}
.price-field .v-label {
  font-size: 18px !important; /* increase label size */
  font-weight: 800;           /* optional - make it bolder */
}

</style>
